<template>
    <div class="keywordRanking">
        <!-- 网站索引数据 -->
        <clientModule class="indexData" moduletitle="关键字排名">
            <div slot="moduletitle">
                关键字排名

                <!-- 网址切换 -->
                <sky-dropdown-select class="site-list" @change="changeSite" v-model="siteId" :options="websiteList"
                    :props="{ label: 'name', value: 'id' }"></sky-dropdown-select>
            </div>
            <div class="tab-style">
                <sky-tabs class="cust-tabs" v-model="tabValue" :tabList="tabList" @change="changeTab"></sky-tabs>
            </div>
        </clientModule>
        <component :is="tabValue" :serviceSiteId="siteId" @getPictureInfo="getPictureInfo"></component>
        <!--  -->
        <!-- 查看快照弹框 -->
		<dialog-form
			:dialogVisible="picVisible"
			:attributes="attributes"
			:showBtn="false"
			@close:dialogVisible="val => (picVisible = val)"
		>
			<div slot="main" class="picture-content">
				<div style="pointer-events: none" v-html="pictureInfo"></div>
			</div>
		</dialog-form>
    </div>
</template>
<script>
import clientModule from '@/components/client/clientModule/clientModule';
import skyDropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';
import { getWebsiteByCustomer } from '@/backend/services/account/service';
import { mapGetters } from 'vuex';
import rankingOverview from './rankingOverview.vue';
import detailedData from './detailedData.vue';
import skyTabs from '@/components/iglobalwin/formComponents/tabs/sky-tabs-custom.vue';
import dialogForm from '@/components/dialogForm/dialogForm';
export default {
    name: 'keywordRanking',
    components: {
        clientModule,
        skyDropdownSelect,
        rankingOverview,
        detailedData,
        skyTabs,
        dialogForm
    },
    data() {
        return {
            websiteList: [],
            siteId: '',
            domain: '',
            tabValue: 'rankingOverview',
            tabList: [
                {
                    label: '排名概览',
                    name: 'rankingOverview',
                },
                {
                    label: '详细数据',
                    name: 'detailedData',
                },
            ],
            picVisible: false,
            pictureInfo: '',
            attributes: {
                title: '关键词搜索结果展示',
                width: '50%',
            },
        }
    },
    computed: {
        ...mapGetters(['customerId']),
    },
    watch: {
        customerId: {
            async handler(val) {
                if (val) this.getWebsite();
                else this.$message.warning('您需要先选择一个客户');
            },
            immediate: true,
            deep: true,
        },
        '$route.query.tabs': {
            handler(val) {
                if (val) this.tabValue = val;
                else this.tabValue = 'rankingOverview';
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        // 网站下拉数据
        async getWebsite() {
            try {
                let { customerId } = this;
                let result = await getWebsiteByCustomer({
                    customerId,
                });
                this.websiteList = result.data;
                if (result.data.length == 0) {
                    this.siteId = ''
                    return false
                }
                this.siteId = result.data[0].id;
                this.domain = result.data[0].name;
            } catch (error) {
                console.log(error);
            }
        },
        // 网址选择切换
        changeSite(id) {
            let obj = this.websiteList.find(item => {
                return item.id === id;
            });
            this.domain = obj.name;
        },
        changeTab(val) {
            if (val == 'rankingOverview') this.$router.push({ path: 'keywordRanking' });
        },
        getPictureInfo(data) {
			this.pictureInfo = data;
			this.picVisible = true;
		},
    }
}
</script>
<style lang="scss" scoped>
.keywordRanking {
    min-height: calc(100vh - 175px);
    margin: 0px 20px 10px 20px;
}
.picture-content {
		height: 700px;
		overflow-y: auto;
		overflow-x: hidden;
		position: relative;
		user-select: none;
		padding: 0 50px;

		// 给v-html文件下所有的标签加上样式
		div {
			::v-deep  div {
				pointer-events: none;
				div,
				span,
				a {
					pointer-events: none;
					div,
					span,
					a {
						pointer-events: none;
					}
				}
			}
		}

		// 改变滚动条样式
		&::-webkit-scrollbar {
			width: 8px;
		}

		&::-webkit-scrollbar-thumb {
			background-color: #e8e8e8;
			border-radius: 6px;
		}

		&::-webkit-scrollbar-track {
			background-color: #fff;
			border-radius: 4px;
		}
	}

.indexData {
    background-color: #fff;

    .site-list {
        margin-left: 20px;
    }

    .tab-style {
		padding: 15px 24px;
		box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
		border-radius: 4px;
		position: relative;

		

		::v-deep  .el-tabs__nav-wrap {
			overflow: inherit;
		}

		::v-deep  .el-tabs__nav-scroll {
			overflow: inherit;
		}

		::v-deep  .el-tabs__active-bar {
			bottom: -14px;
		}
	}
}
</style>
